import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';

import { AddvideoComponent } from '../addvideo/addvideo.component';
import { AddemployeeComponent } from '../addemployee/addemployee.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { GmDashboardService } from '../gm-dashboard.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { VideoComponent } from '../video/video.component';
import { AddcameradialogComponent } from '../addcameradialog/addcameradialog.component';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { DragDropTransferService } from '../drag-drop-transfer.service';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs';
import { InputAlertComponent } from '../../input-alert/input-alert.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HighchartsService } from 'src/app/piechart/highcharts.service';
import { AlertComponent } from 'src/app/alert/alert.component';

@Component({
  selector: 'app-gmdashboard',
  templateUrl: './gmdashboard.component.html',
  styleUrls: ['./gmdashboard.component.scss']
})
export class GmdashboardComponent implements OnInit, OnDestroy {
  show: boolean = true
  search: boolean = true
  campusdata: any;
  campusData: any;
  buildingData: any;
  dialogRef: any;
  employes: any;
  imageChange: any = 'scale(1)';
  searchTerm: string = '';
  searchemployesslist: any;
  existingcamera: any;
  selectedImages: any = [];
  data1: any;
  empid: any;
  emp: any;
  // tempPayrollId:string=HYD103135
  tempPayrollId: any;
  imageUrls: string[] = [];
  droppedCameras: any[] = [];
  imageUrl: string;
  employee: any;
  cameraid: any;
  delected: Object;
  cctv: any;
  bulidingname: any;
  buildingname: any;
  subscription: any;

  campusControl: any = new FormControl();
  buildingControl: any = new FormControl();
  filteredCampuses: any;
  cctvcameralist: any;
  buildingid: any;
  filteredBuildings: any;
  buildingId: any;
  channelName: any;
  showDropContainer: any;
  empDetails: any;
  servicelist: any;
  constructor(private dashboard: GmDashboardService, private dialog1: NgDialogAnimationService, private highcharts: HighchartsService,
    private dailog: MatDialog, private toast: ToastmessageService, private dragDropService: DragDropTransferService, private cdr: ChangeDetectorRef, private spinner: NgxSpinnerService) {
    this.subscription = this.dragDropService.droppedItem$.subscribe(item => {
      console.log('Received item from dialog:', item);
      console.log(this.existingcamera)
      if (!item.item.alreadyAdded) {
        this.droppedCameras.push(item);
      }
      else {
        this.dailog.open(AlertComponent, {
          width: '400px',
          height: '60px',
          position: { top: '10px', right: '10px' },
          data: {
            data: "Camera Already Added",
            status: "Warning"

          },
        })
      }
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  // allowDrop(event: DragEvent) {
  //   event.preventDefault();
  // }
  ngOnInit(): void {
    this.AllServices();
    this.spinner.show()
    // this.campuslist()

  }
  allowDrop(event: DragEvent) {
    event.preventDefault();
  }
  private Filter(value: string, list: any[], name: string): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
  }
  open() {
    this.dialogRef = this.dialog1.open(AddemployeeComponent, {
      width: "310px",
      height: "100%",
      position: { right: '0' },
      maxWidth: '100%',
      animation: { to: 'left' },
      autoFocus: false,
      disableClose: true,
      // hasBackdrop: false,
      data: this.searchemployesslist,
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value != true && value?.empId) {
        this.page(value)
      }
    })
  }
  onDrop(event: CdkDragDrop<any>) {
    const camera = event.item.data;
    const channelDialog = this.dailog.open(InputAlertComponent, {
      width: '400px',
      height: '220px',
      data: 'Camera Location Name'
    })
    channelDialog.afterClosed().subscribe((res: any) => {
      this.channelName = res;
      if (this.channelName) {
        this.cctvcameralist.cameraDetails = this.cctvcameralist.cameraDetails.filter(
          (cam: any) => cam !== camera
        );
        const data = {
          'buildingName': this.cctvcameralist.buildingName,
          'item': camera,
          'channelName': this.channelName
        }
        this.dragDropService.sendDroppedItem(data);
      }
    })
  }
  opensearch() {
    this.dialogRef = this.dialog1.open(AddvideoComponent, {
      width: "510px",
      height: "100%",
      position: { right: '0' },
      maxWidth: '100%',
      animation: { to: 'left' },
      autoFocus: false,
      disableClose: true,
      // hasBackdrop: false,
      data: this.searchemployesslist,
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {

      //  this.page(this.employee)

      this.dashboard.getemployecamera(this.empid).subscribe((res: any) => {
        this.existingcamera = res

      })
    })
  }

  toggleSelection(image: any) {
    image.isSelected = !image.isSelected;
    this.selectedImages.push(image)
  }
  openCameraDialog(item: any) {
    const dialogRef1 = this.dailog.open(AddcameradialogComponent, {
      data: {
        camera: item,
        empDetails: this.employee,
        buildingName: this.cctvcameralist.buildingName
      },
      width: '90%', height: '90%',
    })
    dialogRef1.afterClosed().subscribe((value: any) => {
      this.dashboard.getempyoleaddcamera(this.buildingId, this.empid).subscribe(res => {
        this.cctvcameralist = res
        const droppedIds = this.droppedCameras.map(cam => cam.item?.cctvStatusId);
        this.cctvcameralist.cameraDetails = this.cctvcameralist.cameraDetails.filter(
          (cam: any) => !droppedIds.includes(cam.cctvStatusId)
        );
        console.log('cam', this.cctvcameralist)
      })
    })
  }
  Dashboard() {
    this.spinner.show()
    this.show = true
    //  this.employee()
    this.employess()
    this.campusData = ''
    this.buildingData = ''
    this.cctvcameralist = ''
    this.spinner.hide()
  }
  employess() {
    this.spinner.show()
    this.dashboard.getemployeesdashboard().subscribe((res: any) => {
      this.spinner.show()
      this.employes = res

      // this.tempPayrollId='HYD310809'
      // this.imageUrl = `http://scaits.info/attachment/empImage/${this.tempPayrollId?.toUpperCase()}_Photo.jpg`;
      this.employes.forEach((emp: any) => {
        this.getImage(emp);
      });
      // this.imageUrls = this.employes.map((emp: any) =>
      //   `http://scaits.info/attachment/empImage/${emp.payRollId?.toUpperCase()}_Photo.jpg`
      // );
      this.spinner.hide()
    })
  }

  onCampusChange(event: any) {
    const selectedCampusId = event.campusId;
    if (selectedCampusId) {
      this.getBuilding(selectedCampusId);
      this.campusControl.setValue('');
    }
  }
  onbuilding(event: any) {
    this.spinner.show()
    this.buildingId = event.buildingId;
    if (this.buildingId) {
      this.getcctv(this.buildingId);
    }
  }
  onItemDropped(item: any) {
  }
  getBuilding(selectedCampusId: any) {
    this.spinner.show()
    this.dashboard.getbuildingdashboard(selectedCampusId).subscribe((res: any) => {
      this.buildingData = res;
      this.filteredBuildings = this.buildingControl.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.buildingData, 'buildingName'))
      );
      this.buildingid = this.buildingData.buildingId
      console.log("list", this.buildingData);
      this.cctvcameralist = ''
    })
    this.spinner.hide()
  }
  getcctv(buildingId: any) {
    this.dashboard.getempyoleaddcamera(buildingId, this.empid).subscribe(res => {
      this.cctvcameralist = res;
    })
    this.spinner.hide()
  }


  openDialog(event: Event, image: any) {
    console.log('ddd', image)
    this.dailog.open(VideoComponent, {
      data: image,
      width: '90%', height: '80%',
    })
  }
  selectImage(event: Event, image: any) {
    event.preventDefault();
    event.stopPropagation();

    image.isSelected = !image.isSelected
    if (image.isSelected) {
      this.cctv = this.selectedImages.cctvStatusId
      console.log("cctvid", this.cctv);

      this.selectedImages.push(image)
      console.log('select Image', this.selectedImages)
    } else if (!image.isSelected) {

      this.selectedImages = this.selectedImages.filter((item1: any) => item1.dvrChannelId != image.dvrChannelId
      );
      console.log("deseclected", this.selectedImages);

    }
  }
  page(emp: any) {
    this.spinner.show()
    this.show = false
    this.employee = emp
    this.empDetails = emp
    console.log(this.employee)
    this.employee = emp.payRollId !== undefined ? emp.payRollId : emp.payrollId;
    this.dashboard.campusdashboard(this.employee).subscribe((res: any) => {
      this.campusData = res;
      this.filteredCampuses = this.campusControl.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.campusData, 'campusName'))
      );
      this.campusControl.setValue('');
      console.log("list", this.campusData);
    });

    console.log("data", emp);
    // this.emp=emp.payRollId
    this.emp = emp.payRollId !== undefined ? emp.payRollId : emp.payrollId;
    console.log(emp);

    this.dashboard.getemployesssearch(this.emp).subscribe((res: any) => {
      this.searchemployesslist = res,
        // this.imageUrls = this.searchemployesslist[0].map(emp =>
        //   `http://scaits.info/attachment/empImage/${emp.payRollId?.toUpperCase()}_Photo.jpg`
        // );
        this.searchemployesslist = Array.isArray(res) ? res : [res];
      this.empid = res.empId
      this.searchemployesslist.forEach((empy: any) => {
        this.getImage(empy);
        this.empid = empy.empId;
      });
      //   this.imageUrl = `http://scaits.info/attachment/empImage/${this.searchemployesslist?.payrollId?.toUpperCase()}_Photo.jpg`
      // this.empid = this.searchemployesslist.empId
      console.log("id", this.empid);
      this.exictingcamera(this.empid)
    })

  }
  employessearch() {
    console.log("employess", this.searchTerm);
    this.dashboard.getemployesssearch(this.searchTerm).subscribe((res: any) => {
      this.searchemployesslist = res
      this.empid = this.searchemployesslist[0].empId
      console.log("id", this.empid);
      this.exictingcamera(this.searchemployesslist[0].empId)
    })
    this.searchTerm = ''

  }

  exictingcamera(empid: any) {
    this.dashboard.getemployecamera(empid).subscribe((res: any) => {
      this.existingcamera = res
    })
    this.spinner.hide()
  }
  openvideostreaming(event: Event, image: any) {
    this.dailog.open(VideoComponent, {
      data: image,
      width: '90%', height: '90%',
    })
  }
  deleteSelectedImages() {
    // if (this.selectedImages.length == 1) {
    //   this.cameraid = this.selectedImages[0].dvrChannelId
    //   this.bulidingname=this.selectedImages[0].bulidingName
    //   if(confirm("Do You Want Delected in Camera bulidingName")){
    //   this.dashboard.getdelectedcamera(this.cameraid).subscribe(res => {
    //     this.delected = res
    //     this.dashboard.getemployecamera(this.empid).subscribe(res => {
    //       this.existingcamera = res
    //     })
    //     this.selectedImages = this.selectedImages.filter((item1: any) => item1.dvrChannelId != this.cameraid)
    //   })
    // };
    // } else {
    //   alert("Please the Selected one Camera in delected ")
    // }
    if (this.selectedImages.length == 1) {
      this.cameraid = this.selectedImages[0].dvrChannelId;
      this.buildingname = this.selectedImages[0].buildingName;
      if (confirm("Do you want to delete the camera in buildingName " + this.buildingname + "?")) {
        this.dashboard.getdelectedcamera(this.cameraid).subscribe(res => {
          this.delected = res;
          this.dashboard.getemployecamera(this.empid).subscribe(res => {
            this.existingcamera = res;
          });
          this.selectedImages = this.selectedImages.filter((item1: any) => item1.dvrChannelId != this.cameraid);
        });
        this.toast.showSuccess(' Camera will be delected Successfully')
      }
    } else {
      // alert("Please select one camera to delete in building " );
      this.toast.showError("Please Select one Camera to delete in building ")
    }
  }
  // updateSelectedImages() {
  //   this.selectedImages = this.images.filter(image => image.isSelected);
  // }
  onCameraDropToGM(event: DragEvent) {
    event.preventDefault();

    const jsonData = event.dataTransfer?.getData('application/json');
    if (!jsonData) return;

    const data = JSON.parse(jsonData);

    const dialogRef = this.dialog1.open(AddcameradialogComponent, {
      width: '80%',
      height: '80%',
      data: {
        camera: data.camera,
        buildingName: data.buildingName,
        empDetails: data.empDetails
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'saved') {
        // this.refreshDashboard();
      }
    });
  }

  saveDraggedCameras() {
    this.spinner.show()
    console.log(this.droppedCameras)
    const cameraList = this.droppedCameras.map((e: any) => ({
      payRollId: this.empDetails.payRollId
        ? this.empDetails.payRollId
        : this.empDetails.payrollId,
      empId: this.empDetails.empId,
      empName: this.empDetails.empName,
      designation: this.empDetails.designation,
      camerasAlloted: this.empDetails.camerasAlloted,
      dvrDetails: {
        dvrName: e.buildingName,
        cctvDetId: e.item.cctvDetId,
        cameras: [
          {
            channelNo: e.item.channelNo,
            channelName: e.channelName
          }
        ]
      },
      dashboardUserId: this.empDetails.dashboardUserId
    }));
    console.log(cameraList)
    this.dashboard.saveDraggedcammera(cameraList).subscribe({
      next: (res: any) => {
        console.log(res)
        this.droppedCameras = []
        this.dashboard.getemployecamera(this.empid).subscribe({
          next: (res: any) => {
            if (!res) {
              return;
            }
            this.existingcamera = res
            this.spinner.hide()
            // this.cdr.detectChanges();
          }

        })
      },
      error: (err: any) => {
        console.log(err)
        this.spinner.hide()
      }
    })

  }


  // refreshDashboard() {
  //   this.api.getCameraList().subscribe((res) => {
  //     console.log('Refreshed dashboard camera data:', res);
  //     // Update UI with new data
  //   });
  // }


  AllServices() {
    if (this.highcharts.getRoles().length == 0) {
      this.spinner.show();
      this.highcharts.modulebaseurl().subscribe(
        {
          next: (res: any) => {
            this.servicelist = res;
            this.spinner.hide();

            console.log('service', this.servicelist);
            this.highcharts.setRoles(this.servicelist.moduleBaseURl);
            console.log('roleitem', this.highcharts.getRoles());
            this.employess()

          },
          error: (error: any) => {
            this.spinner.hide();
          }
        }
      )
    }
  }
  getImage(emp: any) {
    this.spinner.show()
    const payrollId = emp.payrollId || emp.payRollId;
    this.dashboard.getimage(payrollId).subscribe({

      next: (blob: Blob) => {
         this.spinner.show();
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          emp.imageUrl = reader.result as string;
          this.spinner.hide();

        };
      },
      error: (err: any) => {
        emp.imageUrl = 'assets/images/employee_notpresent.jpg';
        this.spinner.hide();
      }
    })

  }
}

